import React from 'react';

import { InfoBadge } from '@tmapy/style-guide';

import type { NestedPriceListItemResponse } from '../../openapi/types/NestedPriceListItem';
import { PriceIcon } from '../../publishsets/components/PriceIcon';
import { ApprovalIcon } from './ApprovalIcon';

type PublishsetSummaryItemProps = {
  name: string;
  needsApproval?: boolean;
  formats: string[];
  priceListItem?: NestedPriceListItemResponse | null;
  priceListItemName?: string | null;
};

export const PublishsetSummaryItem: React.FC<PublishsetSummaryItemProps> = (props) => {
  return (
    <div className='sg-a-d-f sg-a-ai-b sg-u-hsl-1'>
      <span>{props.name}</span>
      {(props.priceListItem || props.priceListItemName) && (
        <PriceIcon
          priceListItem={props.priceListItem}
          priceListItemName={props.priceListItemName}
        />
      )}
      {props.needsApproval && <ApprovalIcon />}
      {props.formats.map((format) => (
        <InfoBadge key={format}>{format}</InfoBadge>
      ))}
    </div>
  );
};
